<template>
  <div class="app-container">
    <Transition name="fade">
      <div v-if="sidebarOpen && isMobile" class="sidebar-overlay" @click="sidebarOpen = false"></div>
    </Transition>

    <aside :class="['sidebar', { 'closed': !sidebarOpen, 'is-mobile': isMobile }]">
      <div class="sidebar-header">
        <div class="logo-box">
          <div class="logo-dot"></div>
          <span class="logo-text">mcframe <small>Data Copilot</small></span>
        </div>
      </div>
      
      <div class="sidebar-content">
        
        <button class="new-btn-tech" @click="createNewChat">
            <div class="btn-scan-line"></div>
            <div class="btn-content">
                <span class="plus-icon">+</span>
                <span class="btn-text">新規対話</span>
            </div>
            <div class="btn-corner-deco"></div>
        </button>
        
        <div class="nav-label-container">
          <span class="nav-label">最近の履歴</span>
          <div class="nav-line"></div>
        </div>

        <div class="chat-list">
          <div 
            v-for="chat in conversations" :key="chat.id" 
            :class="['chat-item', { active: chat.id === activeId }]" 
            @click="handleChatClick(chat.id)"
          >
            <div :class="['tech-icon-container', chat.iconType || 'unit']">
              <div class="icon-core"></div><div class="icon-ring"></div>
            </div>
            <span class="title-text">{{ chat.title }}</span>
          </div>
        </div>
      </div>
    </aside>

    <main class="main-content">
      <header class="top-bar">
        <div class="top-bar-left">
          <button class="icon-btn" @click="sidebarOpen = !sidebarOpen">☰</button>
          <!-- <div class="header-info">
            <span class="status-dot"></span> 
            <span class="status-text">{{ isMobile ? 'Active' : 'SYSTEM READY' }}</span>
          </div> -->
        </div>
        <div class="top-bar-right">
          <div v-if="!isLoggedIn" class="login-trigger" @click="showLoginModal = true">👤 ログイン</div>
          <div v-else class="user-profile-trigger" @click="showUserMenu = !showUserMenu">
            <div class="avatar-blue-glow">System</div>
          </div>

           <Transition name="terminal-fade">
                <div v-if="showUserMenu && isLoggedIn" class="system-modal-mask" @click.self="showUserMenu = false">
                    
                    <div class="user-info-terminal">
                        <div class="terminal-scanner"></div>
                        
                        <div class="terminal-header">
                            <button class="btn-abort-top" @click="showUserMenu = false">
                            <span>CLOSE</span>
                            </button>
                        </div>

                        <div class="terminal-body">
                            <div class="profile-section">
                            <div class="avatar-capsule">
                                <div class="avatar-box">SY</div>
                                <div class="avatar-glow"></div>
                            </div>
                            <div class="meta-box">
                                <h3>{{ userData.username }}</h3>
                                <p class="status-tag">ACTIVE ADMINISTRATOR</p>
                            </div>
                            </div>

                            <div class="data-terminal-grid">
                            <div class="data-item">
                                <label>登録日</label>
                                <span class="value">{{ userData.regDate }}</span>
                            </div>
                            <div class="data-item">
                                <label>累計費用</label>
                                <span class="value cyan-text">{{ userData.totalSpend }}</span>
                            </div>
                            </div>

                            <div class="action-footer">
                            <button class="btn-tech switch" @click="switchUser">
                                <span>ユーザー切り替え</span>
                            </button>
                            <button class="btn-tech logout" @click="logout">
                                <span>ログアウト</span>
                            </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
         
        </div>
      </header>

      <div class="chat-viewport" ref="scrollRef" @touchstart="handleTouchStart">
        <div class="message-list">
          <div v-for="(msg, i) in currentChat.messages" :key="i" :class="['message-row', msg.role]">
            <div class="avatar">{{ msg.role === 'user' ? 'ME' : 'AI' }}</div>
            <div class="bubble-wrapper">
              <div class="bubble-tech">
                <template v-if="msg.isStreaming">
                  <div class="loading-status-box">
                    <AiThinking /><span class="loading-text">ANALYZING...</span>
                  </div>
                </template>
                <template v-else>
                  <div class="text-content" v-html="formatContent(msg.content)"></div>
                  <div v-if="msg.chartType" class="chart-container-box">
                    <ChatChart :type="msg.chartType" :chartData="msg.chartData" :field="msg.field" />
                  </div>
                  <div v-if="msg.aiAnswer" :class="activeId === 1 ? 'simple-example-box' : 'ai-answer-content'">
                    <p v-html="formatAiAnswer(msg.aiAnswer)"></p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="input-area">
        <div class="input-wrapper">
          <textarea 
            ref="inputRef"
            v-model="userInput" 
            placeholder="メッセージを入力..." 
            @keydown.enter="handleEnter" 
            @focus="handleInputFocus"
            rows="1"
          ></textarea>
          <div class="input-actions-group">
            <SpeechInput @recognized="userInput = $event" />
            <button
              @mousedown.prevent
              @click="send"
              class="send-btn"
              :class="{ active: userInput.trim() }"
              :disabled="!userInput.trim() || isChatting"
            >
              <Send class="send-icon" />
            </button>
          </div>
        </div>
      </footer>
    </main>

    <Transition name="fade-slide">
        <div v-if="showLoginModal" class="login-fullscreen-overlay">
            <div class="tech-grid-bg"></div>

            <div class="auth-terminal-frame">
                <div class="scanner-line"></div>

                <div class="auth-inner-content">

                    <div class="auth-form">
                        <div class="input-group">
                            <label class="hud-label-mini">アカウントID</label>
                            <div class="tech-input-wrapper">
                            <span class="tech-prefix">ID</span>
                            <input v-model="loginForm.username" type="text" placeholder="IDを入力してください" />
                            <div class="focus-glow"></div>
                            </div>
                        </div>

                        <div class="input-group">
                            <label class="hud-label-mini">パスワード</label>
                            <div class="tech-input-wrapper">
                            <span class="tech-prefix">PW</span>
                            <input v-model="loginForm.password" type="password" placeholder="••••••••" @keyup.enter="handleLogin" />
                            <div class="focus-glow"></div>
                            </div>
                        </div>
                    </div>

                    <div class="auth-actions-group">
                        <button class="btn-tech-primary" @click="handleLogin">
                            <span class="btn-glitch-text">システム起動</span>
                        </button>
                        
                        <button class="btn-tech-cancel" @click="showLoginModal = false">
                            <span>キャンセル</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, nextTick, computed, onMounted, onUnmounted } from 'vue';
import ChatChart from '../components/ChatChart.vue';
import AiThinking from '../components/chat/AiThinking.vue';
import SpeechInput from '../components/SpeechInput.vue';
import { Send } from 'lucide-vue-next';

// 状态管理
const userInput = ref('');
const isChatting = ref(false);
const scrollRef = ref(null);
const inputRef = ref(null);
const sidebarOpen = ref(true);
const isMobile = ref(false);
const isLoggedIn = ref(false);
const showLoginModal = ref(false);
const showUserMenu = ref(false);
const loginForm = ref({ username: '', password: '' });
const loginError = ref('');
const userData = ref({ username: 'System Admin', regDate: '2026/01/22', totalSpend: '¥128,450' });

// 响应式监听：使用 dvh 适配移动端
const checkWidth = () => {
  isMobile.value = window.innerWidth <= 1024;
  if (isMobile.value) sidebarOpen.value = false;
  else sidebarOpen.value = true;
};

// 移动端输入框聚焦处理：防止键盘遮挡
const handleInputFocus = () => {
  if (isMobile.value) {
    setTimeout(() => {
      scrollRef.value?.scrollTo({ top: scrollRef.value.scrollHeight, behavior: 'smooth' });
    }, 300);
  }
};

// 触摸屏幕收起键盘（可选体验优化）
const handleTouchStart = () => {
  if (isMobile.value && inputRef.value === document.activeElement) {
    inputRef.value.blur();
  }
};

onMounted(() => {
  checkWidth();
  window.addEventListener('resize', checkWidth);
});
onUnmounted(() => window.removeEventListener('resize', checkWidth));

const handleChatClick = (id) => {
  activeId.value = id;
  if (isMobile.value) sidebarOpen.value = false;
};

const conversations = ref([
  { id: 1, iconType: 'main', title: 'データインサイト分析', messages: [{ 
      role: 'assistant', content: 'ご利用ありがとうございます。mcframe Data Copilotです。\n受注、売上、出荷といった販売実績から、生産計画、在庫、原価情報まで、mcframeに蓄积されたデータを基に状况照会や高度な分析をサポートいたします。\n\nどのような情報を确认されますか？', 
      aiAnswer: '【入力例】\n■ 「製品カテゴリ別の売上构成比をグラフで見せて」', 
      isStreaming: false }]
  },
  { id: 'demo-1', iconType: 'risk', title: '【サンプル】2025年度 受注残推移', messages: DEMO_INITIAL_CONVERSATIONS['demo-1'] || [] }
]);

const activeId = ref(1);
const currentChat = computed(() => conversations.value.find(c => c.id === activeId.value) || conversations.value[0]);

const formatContent = (t) => t?.replace(/\*\*(.*?)\*\*/g, '<b class="highlight">$1</b>').replace(/\n/g, '<br>') || '';
const formatAiAnswer = (t) => t ? formatContent(t.replace(/\*\*(.*?)\*\*/g, '<b class="highlight">$1</b>')) : '';

const send = async () => {
  const text = userInput.value.trim();
  if (!text || isChatting.value) return;
  currentChat.value.messages.push({ role: 'user', content: text });
  userInput.value = ''; 
  isChatting.value = true;
  await nextTick(); 
  scrollRef.value.scrollTo({ top: scrollRef.value.scrollHeight, behavior: 'smooth' });

  const aiMsg = ref({ role: 'assistant', content: '', isStreaming: true, statusText: 'SEARCHING...' });
  currentChat.value.messages.push(aiMsg.value);

  try {
    const res = checkDemoResponse(text);
    await new Promise(r => setTimeout(r, 1500));
    aiMsg.value.content = res ? "分析結果を表示します：" : "mcframeから抽出したデータをご確認ください。";
    if (res) {
      aiMsg.value.chartType = String(res.type); 
      aiMsg.value.chartData = res.data || res.chartData || []; 
    }
  } catch (e) {
    aiMsg.value.content = 'エラーが発生しました。';
  } finally {
    aiMsg.value.isStreaming = false; 
    isChatting.value = false;
    await nextTick(); 
    scrollRef.value.scrollTo({ top: scrollRef.value.scrollHeight, behavior: 'smooth' });
  }
};

const handleLogin = () => { isLoggedIn.value = true; showLoginModal.value = false; };
const logout = () => { isLoggedIn.value = false; showUserMenu.value = false; };
const switchUser = () => { showUserMenu.value = false; isLoggedIn.value = false; showLoginModal.value = true; };
const handleEnter = (e) => { if (!e.shiftKey && !isMobile.value) { e.preventDefault(); send(); } };
const createNewChat = () => {
  const newId = Date.now();
  conversations.value.unshift({ id: newId, title: '新規対話', messages: [] });
  activeId.value = newId;
  if (isMobile.value) sidebarOpen.value = false;
};
</script>

<style scoped>
/* --- 全局布局优化 --- */
.app-container {
  display: flex;
  width: 100vw;
  height: 100dvh; /* 动态视口高度，适配移动端浏览器工具栏 */
  background-color: #030612;
  overflow: hidden;
  font-family: 'Inter', -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* --- 侧边栏：移动端抽屉重构 --- */
.sidebar {
  width: 280px;
  background: #04081a;
  border-right: 1px solid rgba(0, 123, 255, 0.15);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2000;
}

@media (max-width: 1024px) {
  .sidebar.is-mobile {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    transform: translateX(0);
    box-shadow: 20px 0 50px rgba(0,0,0,0.8);
  }
  .sidebar.is-mobile.closed { transform: translateX(-100%); }
  .sidebar-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.7);
    backdrop-filter: blur(4px);
    z-index: 1500;
  }
}

.nav-label-container {
  padding: 30px 24px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.nav-label {
  font-size: 10px;
  color: #475569;
  letter-spacing: 2.5px;
  font-weight: 800;
  white-space: nowrap;
}

.nav-line { flex: 1; height: 1px; background: linear-gradient(90deg, rgba(71, 85, 105, 0.3), transparent); }

.chat-item {
  padding: 14px 24px;
  margin: 4px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: 0.2s;
}

.chat-item.active { background: rgba(0, 123, 255, 0.1); border: 1px solid rgba(0, 123, 255, 0.2); }

.title-text {
  font-size: 13px;
  color: #94A3B8;
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* --- 主区域与顶部栏 --- */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: radial-gradient(circle at 50% 0%, #0a1645 0%, #050a1a 100%);
}

.top-bar {
  height: 65px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(6,11,40,0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 123, 255, 0.15);
}

.logo-text {
  font-weight: 800;
  letter-spacing: 0.5px;
  background: linear-gradient(90deg, #fff 0%, #007BFF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

/* --- 聊天内容：气泡质感优化 --- */
.chat-viewport { flex: 1; overflow-y: auto; padding: 20px 0; -webkit-overflow-scrolling: touch; }
.message-list { max-width: 1000px; margin: 0 auto; padding: 0 16px; }

.bubble-tech {
  padding: 18px 22px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 15px;
  line-height: 1.7;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.user .bubble-tech {
  background: linear-gradient(135deg, rgba(0, 64, 255, 0.15), rgba(0, 123, 255, 0.2));
  border-color: rgba(0, 123, 255, 0.3);
}

.chart-container-box {
  width: 100%;
  overflow-x: auto;
  margin-top: 15px;
  background: rgba(0,0,0,0.2);
  border-radius: 12px;
  padding: 10px;
}

/* --- 底部输入区：核心适配 --- */
.input-area {
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: rgba(6, 11, 40, 0.95);
  border-top: 1px solid rgba(0, 123, 255, 0.2);
}

.input-wrapper {
  max-width: 900px;
  margin: 0 auto;
  background: #111827;
  border: 1px solid rgba(0, 123, 255, 0.3);
  border-radius: 14px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.3);
}

textarea {
  flex: 1;
  min-width: 0;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 16px !important; /* iOS 禁止自动缩放 */
  line-height: 1.5;
  outline: none;
  resize: none;
  padding: 4px 0;
  appearance: none;
  -webkit-tap-highlight-color: transparent;
}

.send-btn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, #1e293b, #050a1a);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.send-btn.active {
  background: radial-gradient(circle at 30% 30%, #2563eb, #091f4d);
  box-shadow: 0 0 15px rgba(37, 99, 235, 0.5);
}

.send-btn:active { transform: scale(0.9); }

/* --- 登录框适配 --- */
.lambo-blue-card-large {
  width: 92%;
  max-width: 440px;
  background: #080d26;
  padding: 40px 28px;
  position: relative;
  border: 1px solid #0040FF;
  clip-path: polygon(0 20px, 20px 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%);
}

@media (max-width: 480px) {
  .lambo-blue-card-large { padding: 35px 20px; clip-path: none; border-radius: 12px; }
  .login-overlay { align-items: flex-start; padding-top: 10vh; }
}

.hud-label { font-size: 10px; color: #00D1FF; letter-spacing: 2px; font-weight: 700; margin-bottom: 8px; display: block; }
.lambo-input-container input {
  width: 100%;
  background: rgba(0,64,255,0.1);
  border: 1px solid rgba(0,64,255,0.3);
  padding: 14px;
  color: #fff;
  font-size: 16px !important;
  border-radius: 4px;
}

.input-actions-group {
  display: flex;        /* 内部图标横向排列 */
  align-items: center;  /* 图标居中对齐 */
  gap: 8px;             /* 两个图标之间的间距 */
  flex-shrink: 0;       /* 核心：禁止被左侧 textarea 压缩，确保宽度固定 */
  white-space: nowrap;  /* 辅助：强制不换行 */
  /* 针对移动端微调：确保图标在键盘弹出时不位移 */
  padding-bottom: 2px;  
}

/* 全屏基础容器 */
.login-fullscreen-overlay {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  background: #02040a;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 核心内容框 */
.auth-terminal-frame {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding: 40px;
  background: rgba(10, 20, 50, 0.4);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(0, 123, 255, 0.2);
  /* 尖锐切角风格 */
  clip-path: polygon(0 20px, 20px 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%);
}

/* 输入框对齐与底色风格 */
.tech-input-wrapper {
  display: flex;
  align-items: center;
  background: rgba(0, 40, 100, 0.2); /* 统一深蓝底色 */
  border: 1px solid rgba(0, 102, 255, 0.3);
  padding: 0 15px;
  height: 54px;
  margin-bottom: 25px;
  position: relative;
  transition: 0.3s;
}

.tech-prefix {
  font-size: 11px;
  color: #007BFF;
  font-weight: 900;
  margin-right: 15px;
  opacity: 0.7;
}

.tech-input-wrapper input {
  flex: 1;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 15px;
  outline: none;
}

.focus-glow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #00D1FF;
  transition: 0.4s ease;
}

.tech-input-wrapper:focus-within {
  background: rgba(0, 100, 255, 0.1);
  border-color: #00D1FF;
  box-shadow: 0 0 15px rgba(0, 209, 255, 0.15);
}

.tech-input-wrapper:focus-within .focus-glow {
  width: 100%;
}

.hud-label-mini {
  display: block;
  font-size: 10px;
  color: #00D1FF;
  letter-spacing: 2px;
  margin-bottom: 8px;
  font-weight: bold;
}

.auth-actions-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 10px;
}

.btn-tech-primary {
  height: 56px;
  background: #0040FF;
  border: none;
  color: #fff;
  font-weight: 900;
  letter-spacing: 4px;
  cursor: pointer;
  clip-path: polygon(5% 0, 100% 0, 95% 100%, 0 100%);
  transition: 0.3s;
}

.btn-tech-primary:hover {
  background: #00D1FF;
  box-shadow: 0 0 25px rgba(0, 209, 255, 0.4);
}

.btn-tech-cancel {
  height: 50px;
  background: rgba(255, 50, 50, 0.05);
  border: 1px solid rgba(255, 50, 50, 0.3);
  color: #ff4d4d;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 2px;
  clip-path: polygon(5% 0, 100% 0, 95% 100%, 0 100%);
  cursor: pointer;
  transition: 0.3s;
}

.btn-tech-cancel:hover {
  background: rgba(255, 50, 50, 0.15);
  border-color: #ff3333;
  color: #fff;
  box-shadow: 0 0 15px rgba(255, 50, 50, 0.2);
}


.new-btn-tech {
  position: relative;
  width: calc(100% - 40px); /* 留出左右边距 */
  height: 50px;             /* 移动端黄金点击高度 */
  margin: 15px auto;
  background: linear-gradient(135deg, rgba(0, 123, 255, 0.1) 0%, rgba(0, 40, 150, 0.2) 100%);
  border: 1px solid rgba(0, 209, 255, 0.3);
  color: #fff;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  clip-path: polygon(12px 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%, 0 12px);
  
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 内部内容布局 */
.btn-content {
  display: flex;
  align-items: center;
  gap: 10px;
  z-index: 2;
}

.plus-icon {
  font-size: 18px;
  font-weight: 300;
  color: #00D1FF;
  text-shadow: 0 0 8px rgba(0, 209, 255, 0.8);
}

.btn-text {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 2px; /* 增加字间距，提升高级感 */
  color: #F1F5F9;
}

/* 科技感动态装饰：扫描光线 */
.btn-scan-line {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 209, 255, 0.15), transparent);
  transform: skewX(-25deg);
  transition: 0.5s;
}

.new-btn-tech:hover .btn-scan-line {
  left: 150%;
  transition: 0.8s;
}

/* 装饰性小角块：增加细节密度 */
.btn-corner-deco {
  position: absolute;
  top: 0;
  right: 0;
  width: 15px;
  height: 15px;
  border-right: 2px solid #00D1FF;
  border-top: 2px solid #00D1FF;
  opacity: 0.6;
}

/* 移动端触控反馈 */
@media (max-width: 1024px) {
  .new-btn-tech {
    height: 54px; /* 手机端稍微加高，更易点按 */
    background: rgba(0, 80, 255, 0.08); /* 稍微加深底色 */
  }
  
  /* 模拟物理按键压下的感觉 */
  .new-btn-tech:active {
    transform: scale(0.96) translateY(1px);
    background: rgba(0, 209, 255, 0.2);
    border-color: #00D1FF;
    box-shadow: 0 0 20px rgba(0, 209, 255, 0.3);
  }
}

/* PC端悬停效果 */
@media (min-width: 1025px) {
  .new-btn-tech:hover {
    border-color: #00D1FF;
    background: rgba(0, 123, 255, 0.2);
    box-shadow: 0 0 15px rgba(0, 209, 255, 0.2);
  }
}

/** 登陆信息弹窗 */
/*全屏遮罩：针对 iPhone WebKit 内核的极致压制 */
.system-modal-mask {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  z-index: 99999; /* 提升至最高级 */
  display: flex;
  align-items: center;
  justify-content: center;

  /* 使用接近纯黑的不透明度 (0.98) */
  background: rgba(2, 4, 15, 0.98) !important; 
  
  /* 针对 iOS 的模糊增强 */
  -webkit-backdrop-filter: blur(60px) saturate(200%); 
  backdrop-filter: blur(60px) saturate(200%);

  /* 额外保险：增加一个极细微的径向渐变，中心亮四周暗，进一步遮盖边缘文字 */
  background-image: radial-gradient(
    circle at center,
    rgba(10, 20, 50, 0.8) 0%,
    rgba(2, 4, 15, 1) 100%
  );
}
/* 验证终端卡片：增加外发光，将视觉焦点强制锁在卡片上 */
.user-info-terminal {
  position: relative;
  width: 92%;
  max-width: 400px;
  background: #0a102b; /* 使用实体颜色，不再依赖透明度 */
  border: 1px solid rgba(0, 209, 255, 0.6);
  padding: 40px 25px;
  box-shadow: 0 0 80px rgba(0, 102, 255, 0.3); /* 蓝光溢出感 */
  clip-path: polygon(0 0, 100% 0, 100% calc(100% - 30px), calc(100% - 30px) 100%, 0 100%);
}

/* 显式取消按钮：增加对比度，防止在黑底上看不清 */
.btn-abort-top {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 2px;
  cursor: pointer;
  clip-path: polygon(10% 0, 100% 0, 90% 100%, 0 100%);
  margin-bottom: 20px;
  transition: all 0.3s;
}

.btn-abort-top:active {
  background: #ff4d4d;
  border-color: #ff4d4d;
}

/* 信息展示排版 */
.profile-section {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}

.avatar-box {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #0040FF, #00D1FF);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 20px;
}

.status-tag {
  font-size: 10px;
  color: #00D1FF;
  letter-spacing: 2px;
  margin-top: 4px;
}

/* 数据网格 */
.data-terminal-grid {
  border-top: 1px solid rgba(0, 123, 255, 0.2);
  padding: 20px 0;
}

.data-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.data-item label { font-size: 11px; color: #64748B; font-weight: 700; }
.data-item .value { font-size: 13px; font-weight: 600; color: #fff; }
.cyan-text { color: #00D1FF !important; font-family: 'JetBrains Mono', monospace; }

/* 按钮组适配 */
.action-footer {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 10px;
}

.btn-tech {
  width: 100%;
  height: 50px;
  border: none;
  font-weight: 800;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
  transition: 0.2s;
  clip-path: polygon(5% 0, 100% 0, 95% 100%, 0 100%);
}

.btn-tech.switch { background: rgba(0, 80, 255, 0.2); border-left: 2px solid #0040FF; }
.btn-tech.logout { background: rgba(255, 59, 59, 0.1); border-left: 2px solid #ff3b3b; color: #ff8a8a; }

.btn-tech:active { transform: scale(0.96); opacity: 0.8; }

/* 入场动画 */
.terminal-fade-enter-active, .terminal-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
.terminal-fade-enter-from, .terminal-fade-leave-to {
  opacity: 0;
  filter: blur(20px);
  transform: scale(1.05);
}
</style>